import {type ReactNode, useMemo} from "react";

import type {IGalleryImage} from "../types/IGalleryImage";
import {GalleryPicture} from "./GalleryPicture";
import {GalleryVideo} from "./GalleryVideo";

import * as styles from "./GalleryPicturesGrid.module.css";

interface IProps {
    getImageAlt: (index: number, isConstructionImage?: boolean) => string;
    getImageLoading?: (index: number) => HTMLImageElement["loading"];
    getImageWrapperClassName?: (image: IGalleryImage, index: number) => string | undefined;
    images: IGalleryImage[];
    imageLoading?: HTMLImageElement["loading"];
    onImageClick: (index: number) => void;
    lastTile?: ReactNode;
    video?: string | null;
    shouldShowVideo?: boolean;
}

export const GalleryPicturesGrid = (props: IProps) => {
    const {getImageAlt, getImageLoading, getImageWrapperClassName, imageLoading, images, onImageClick, lastTile, shouldShowVideo, video} = props;

    const resolveImageLoading = (index: number) => getImageLoading?.(index) ?? imageLoading;

    const withVideo = video && shouldShowVideo;

    if (!images.length && !withVideo) {
        return null;
    }

    const {evenImages, oddImages} = useMemo(() => {
        const startIndex = withVideo ? 1 : 0;

        return images.reduce<{oddImages: IGalleryImage[]; evenImages: IGalleryImage[]}>(
            (acc, image, index) => {
                const imageWithAlt = {...image, imgAlt: getImageAlt(index)};
                const adjustedIndex = startIndex + index;

                adjustedIndex % 2 === 0 ? acc.evenImages.push(imageWithAlt) : acc.oddImages.push(imageWithAlt);
                return acc;
            },
            {evenImages: [], oddImages: []}
        );
    }, [images, withVideo]);

    // yes, this placement calculation is naive, but this feature is hot... if that bothers anyone, calculate combined images height or whatever
    const evenCount = evenImages.length + (withVideo ? 1 : 0);
    const oddCount = oddImages.length;
    const lastTilePlacement = evenCount > oddCount ? "odd" : "even";

    return (
        <>
            {/* mobile gallery */}
            <div className={styles.mobileGallery}>
                {withVideo && <GalleryVideo url={video} />}

                {images.map((image, index) => {
                    return (
                        <GalleryPicture
                            key={index}
                            loading={resolveImageLoading(index)}
                            wrapperClassName={getImageWrapperClassName?.(image, index)}
                            onClick={() => onImageClick(index)}
                            {...image}
                        />
                    );
                })}

                {lastTile && <div>{lastTile}</div>}
            </div>

            {/* desktop gallery */}
            <div className={styles.galleryRow}>
                <div className={styles.galleryColumn}>
                    {withVideo && <GalleryVideo url={video} />}

                    {evenImages.map((image, index) => {
                        const imageIndex = withVideo ? index * 2 + 1 : index * 2;

                        return (
                            <GalleryPicture
                                key={imageIndex}
                                loading={resolveImageLoading(imageIndex)}
                                wrapperClassName={getImageWrapperClassName?.(images[imageIndex], imageIndex)}
                                onClick={() => onImageClick(imageIndex)}
                                {...image}
                            />
                        );
                    })}

                    {lastTilePlacement === "even" && lastTile && <div>{lastTile}</div>}
                </div>

                <div className={styles.galleryColumn}>
                    {oddImages.map((image, index) => {
                        const imageIndex = withVideo ? index * 2 : index * 2 + 1;

                        return (
                            <GalleryPicture
                                key={imageIndex}
                                loading={resolveImageLoading(imageIndex)}
                                wrapperClassName={getImageWrapperClassName?.(images[imageIndex], imageIndex)}
                                onClick={() => onImageClick(imageIndex)}
                                {...image}
                            />
                        );
                    })}

                    {lastTilePlacement === "odd" && lastTile && <div>{lastTile}</div>}
                </div>
            </div>
        </>
    );
};
import {type ReactNode, useMemo} from "react";

import type {IGalleryImage} from "../types/IGalleryImage";
import {GalleryPicture} from "./GalleryPicture";
import {GalleryVideo} from "./GalleryVideo";

import * as styles from "./GalleryPicturesGrid.module.css";

interface IProps {
    getImageAlt: (index: number, isConstructionImage?: boolean) => string;
    getImageLoading?: (index: number) => HTMLImageElement["loading"];
    getImageWrapperClassName?: (image: IGalleryImage, index: number) => string | undefined;
    images: IGalleryImage[];
    imageLoading?: HTMLImageElement["loading"];
    onImageClick: (index: number) => void;
    lastTile?: ReactNode;
    video?: string | null;
    shouldShowVideo?: boolean;
}

export const GalleryPicturesGrid = (props: IProps) => {
    const {getImageAlt, getImageLoading, getImageWrapperClassName, imageLoading, images, onImageClick, lastTile, shouldShowVideo, video} = props;

    const resolveImageLoading = (index: number) => getImageLoading?.(index) ?? imageLoading;

    const withVideo = video && shouldShowVideo;

    if (!images.length && !withVideo) {
        return null;
    }

    const {evenImages, oddImages} = useMemo(() => {
        const startIndex = withVideo ? 1 : 0;

        return images.reduce<{oddImages: IGalleryImage[]; evenImages: IGalleryImage[]}>(
            (acc, image, index) => {
                const imageWithAlt = {...image, imgAlt: getImageAlt(index)};
                const adjustedIndex = startIndex + index;

                adjustedIndex % 2 === 0 ? acc.evenImages.push(imageWithAlt) : acc.oddImages.push(imageWithAlt);
                return acc;
            },
            {evenImages: [], oddImages: []}
        );
    }, [images, withVideo]);

    // yes, this placement calculation is naive, but this feature is hot... if that bothers anyone, calculate combined images height or whatever
    const evenCount = evenImages.length + (withVideo ? 1 : 0);
    const oddCount = oddImages.length;
    const lastTilePlacement = evenCount > oddCount ? "odd" : "even";

    return (
        <>
            {/* mobile gallery */}
            <div className={styles.mobileGallery}>
                {withVideo && <GalleryVideo url={video} />}

                {images.map((image, index) => {
                    return (
                        <GalleryPicture
                            key={index}
                            loading={resolveImageLoading(index)}
                            wrapperClassName={getImageWrapperClassName?.(image, index)}
                            onClick={() => onImageClick(index)}
                            {...image}
                        />
                    );
                })}

                {lastTile && <div>{lastTile}</div>}
            </div>

            {/* desktop gallery */}
            <div className={styles.galleryRow}>
                <div className={styles.galleryColumn}>
                    {withVideo && <GalleryVideo url={video} />}

                    {evenImages.map((image, index) => {
                        const imageIndex = withVideo ? index * 2 + 1 : index * 2;

                        return (
                            <GalleryPicture
                                key={imageIndex}
                                loading={resolveImageLoading(imageIndex)}
                                wrapperClassName={getImageWrapperClassName?.(images[imageIndex], imageIndex)}
                                onClick={() => onImageClick(imageIndex)}
                                {...image}
                            />
                        );
                    })}

                    {lastTilePlacement === "even" && lastTile && <div>{lastTile}</div>}
                </div>

                <div className={styles.galleryColumn}>
                    {oddImages.map((image, index) => {
                        const imageIndex = withVideo ? index * 2 : index * 2 + 1;

                        return (
                            <GalleryPicture
                                key={imageIndex}
                                loading={resolveImageLoading(imageIndex)}
                                wrapperClassName={getImageWrapperClassName?.(images[imageIndex], imageIndex)}
                                onClick={() => onImageClick(imageIndex)}
                                {...image}
                            />
                        );
                    })}

                    {lastTilePlacement === "odd" && lastTile && <div>{lastTile}</div>}
                </div>
            </div>
        </>
    );
};
